import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'userAccount' as const;
export const FETCH_ACCOUNT_DETAILS = 'FETCH_ACCOUNT_DETAILS' as const;
export const { patterns, resolve, reject, send } = createLifecycleFor(TYPE);
